'use strict'

module.exports = {
  SITE_URL: '"https://rodonavesseguros.com.br/"',
  API_URL: '"https://api.rodonavesseguros.com.br/v1"',
};



//////////////////
// WEBPACK FOOTER
// ./config/local.env.js
// module id = 131
// module chunks = 1